// import React, { useState, useEffect } from "react";
// import toast from "react-hot-toast";
// import { useNavigate, useLocation, useParams } from "react-router-dom";
// import equipmentService from "../../../Services/inventoryService";

// // ── Reusable components ──────────────────────────────────────
// const SectionLabel = ({ children }) => (
//   <p className="text-[11px] uppercase tracking-widest font-[500] text-gray-400 mb-3 mt-6">
//     {children}
//   </p>
// );

// const InputField = ({ label, prefix, ...props }) => (
//   <div className="flex flex-col gap-1">
//     <label className="text-[12px] font-[500] text-gray-500">{label}</label>
//     <div className="relative">
//       {prefix && (
//         <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[12px] text-gray-400">
//           {prefix}
//         </span>
//       )}
//       <input
//         {...props}
//         className={`w-full ${prefix ? "pl-8" : "px-3"} pr-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-400 focus:ring-2 focus:ring-orange-100`}
//       />
//     </div>
//   </div>
// );

// // ── Main Component ───────────────────────────────────────────
// const UpdateEquipment = () => {
//   const [equipmentData, setEquipmentData] = useState({
//     cost_of_maintenance: "",
//     date_of_condemnation: "",
//     date_of_replacement: "",
//     other_relevant_remarks: "",
//   });

//   const { id }       = useParams();
//   const { state }    = useLocation();
//   const navigate     = useNavigate();

//   // Pre-fill from navigation state passed via the Update button
//   useEffect(() => {
//     if (state?.equipment) {
//       const eq = state.equipment;
//       setEquipmentData({
//         cost_of_maintenance:    eq.cost_of_maintenance    || "",
//         date_of_condemnation:   eq.date_of_condemnation   || "",
//         date_of_replacement:    eq.date_of_replacement    || "",
//         other_relevant_remarks: eq.other_relevant_remarks || "",
//       });
//     }
//   }, [state]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setEquipmentData({ ...equipmentData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const payload = {
//         cost_of_maintenance:    equipmentData.cost_of_maintenance,
//         date_of_condemnation:   equipmentData.date_of_condemnation,
//         date_of_replacement:    equipmentData.date_of_replacement,
//         other_relevant_remarks: equipmentData.other_relevant_remarks,
//       };
//       await equipmentService.update(id, payload);
//       toast.success("Equipment updated successfully!");
//       navigate(-1);
//     } catch (error) {
//       toast.error("Error updating equipment.");
//     }
//   };

//   return (
//     <div className="bg-gray-50 flex items-start justify-center py-10 px-4">
//       <div className="w-full max-w-[1400px]">
//         <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">

//           {/* ── Header ── */}
//           <div className="bg-gray-800 px-8 py-5">
//             <h1 className="text-white text-[18px] font-[500] tracking-tight">
//               Update Equipment
//             </h1>
//             <p className="text-gray-400 text-[12px] mt-0.5">
//               Fill in all fields to update the equipment maintenance record
//             </p>
//           </div>

//           <form onSubmit={handleSubmit}>
//             <div className="px-8 py-6">

//               {/* ── Section 1: Maintenance Info ── */}
//               <SectionLabel>Maintenance Information</SectionLabel>
//               <div className="grid grid-cols-2 gap-4">
//                 <InputField
//                   label="Cost of Maintenance"
//                   type="text"
//                   name="cost_of_maintenance"
//                   placeholder="e.g. Rs. 10,000"
//                   value={equipmentData.cost_of_maintenance}
//                   onChange={handleChange}
//                   required
//                 />
//                 <InputField
//                   label="Date of Condemnation"
//                   type="date"
//                   name="date_of_condemnation"
//                   value={equipmentData.date_of_condemnation}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <div className="grid grid-cols-2 gap-4 mt-4">
//                 <InputField
//                   label="Date of Replacement"
//                   type="date"
//                   name="date_of_replacement"
//                   value={equipmentData.date_of_replacement}
//                   onChange={handleChange}
//                   required
//                 />
//                 <InputField
//                   label="Other Remarks"
//                   type="text"
//                   name="other_relevant_remarks"
//                   placeholder="Additional notes"
//                   value={equipmentData.other_relevant_remarks}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               {/* ── Footer ── */}
//               <div className="border-t border-gray-100 mt-8 pt-6 flex items-center justify-between">
//                 <button
//                   type="button"
//                   onClick={() => navigate(-1)}
//                   className="text-[13px] text-gray-400 hover:text-gray-600 transition-colors font-[500]"
//                 >
//                   ← Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="bg-gray-800 hover:bg-gray-700 transition-colors text-white text-[13px] font-[500] px-6 py-2.5 rounded-lg"
//                 >
//                   Update Equipment →
//                 </button>
//               </div>

//             </div>
//           </form>
//         </div>

//         <p className="text-center text-[12px] text-gray-400 mt-4">
//           All fields marked as required must be filled before saving.
//         </p>
//       </div>
//     </div>
//   );
// };

// export default UpdateEquipment;

/////////////////////////////////////////////// RESTRICTION CODE ABOVE ───────────────────────────────────────────


import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import equipmentService from "../../../Services/inventoryService";

// ── Reusable components ──────────────────────────────────────
const SectionLabel = ({ children }) => (
  <p className="text-[11px] uppercase tracking-widest font-[500] text-gray-400 mb-3 mt-6">
    {children}
  </p>
);

const InputField = ({ label, prefix, ...props }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[12px] font-[500] text-gray-500">{label}</label>
    <div className="relative">
      {prefix && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[12px] text-gray-400">
          {prefix}
        </span>
      )}
      <input
        {...props}
        className={`w-full ${prefix ? "pl-8" : "px-3"} pr-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-400 focus:ring-2 focus:ring-orange-100`}
      />
    </div>
  </div>
);

// ── Main Component ───────────────────────────────────────────
const UpdateEquipment = () => {
  const [equipmentData, setEquipmentData] = useState({
    cost_of_maintenance: "",
    date_of_condemnation: "",
    date_of_replacement: "",
    other_relevant_remarks: "",
  });

  const { id }    = useParams();
  const { state } = useLocation();
  const navigate  = useNavigate();

  useEffect(() => {
    if (state?.equipment) {
      const eq = state.equipment;
      setEquipmentData({
        cost_of_maintenance:    eq.cost_of_maintenance    || "",
        date_of_condemnation:   eq.date_of_condemnation   || "",
        date_of_replacement:    eq.date_of_replacement    || "",
        other_relevant_remarks: eq.other_relevant_remarks || "",
      });
    }
  }, [state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEquipmentData({ ...equipmentData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        cost_of_maintenance:    equipmentData.cost_of_maintenance    || null,
        date_of_condemnation:   equipmentData.date_of_condemnation   || null,
        date_of_replacement:    equipmentData.date_of_replacement    || null,
        other_relevant_remarks: equipmentData.other_relevant_remarks || null,
      };
      await equipmentService.update(id, payload);
      toast.success("Equipment updated successfully!");
      navigate(-1);
    } catch (error) {
      toast.error("Error updating equipment.");
    }
  };

  return (
    <div className="bg-gray-50 flex items-start justify-center py-10 px-4">
      <div className="w-full max-w-[1400px]">
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">

          {/* ── Header ── */}
          <div className="bg-gray-800 px-8 py-5">
            <h1 className="text-white text-[18px] font-[500] tracking-tight">
              Update Equipment
            </h1>
            <p className="text-gray-400 text-[12px] mt-0.5">
              Fill in the fields you want to update
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="px-8 py-6">

              {/* ── Section 1: Maintenance Info ── */}
              <SectionLabel>Maintenance Information</SectionLabel>
              <div className="grid grid-cols-2 gap-4">
                <InputField
                  label="Cost of Maintenance"
                  type="text"
                  name="cost_of_maintenance"
                  placeholder="e.g. Rs. 10,000"
                  value={equipmentData.cost_of_maintenance}
                  onChange={handleChange}
                />
                <InputField
                  label="Date of Condemnation"
                  type="date"
                  name="date_of_condemnation"
                  value={equipmentData.date_of_condemnation}
                  onChange={handleChange}
                />
              </div>

              <div className="grid grid-cols-2 gap-4 mt-4">
                <InputField
                  label="Date of Replacement"
                  type="date"
                  name="date_of_replacement"
                  value={equipmentData.date_of_replacement}
                  onChange={handleChange}
                />
                <InputField
                  label="Other Remarks"
                  type="text"
                  name="other_relevant_remarks"
                  placeholder="Additional notes"
                  value={equipmentData.other_relevant_remarks}
                  onChange={handleChange}
                />
              </div>

              {/* ── Footer ── */}
              <div className="border-t border-gray-100 mt-8 pt-6 flex items-center justify-between">
                <button
                  type="button"
                  onClick={() => navigate(-1)}
                  className="text-[13px] text-gray-400 hover:text-gray-600 transition-colors font-[500]"
                >
                  ← Cancel
                </button>
                <button
                  type="submit"
                  className="bg-gray-800 hover:bg-gray-700 transition-colors text-white text-[13px] font-[500] px-6 py-2.5 rounded-lg"
                >
                  Update Equipment →
                </button>
              </div>

            </div>
          </form>
        </div>

        <p className="text-center text-[12px] text-gray-400 mt-4">
          All fields are optional — empty fields will be saved as null.
        </p>
      </div>
    </div>
  );
};

export default UpdateEquipment;